import React, { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

export default function ResidencePageCard({ className, children }: PropsWithChildren<{ className?: string }>) {
  return <div className={twMerge('mb-10 bg-white shadow-xl rounded-xl p-8', className)}>{children}</div>;
}
